import { ArtScapeLogo } from '@components/logo/ArtScape';
import { IceJiTriangleLogo } from '@components/logo/IceJiTriangle';
import { RealMotionLogo } from '@components/logo/RealMotion';
import { Link } from '@/components';
const Footer = () => {
  return <>
      <Link className='h-full w-full fill-black dark:fill-white' href='https://realmotion.co/'>
        <RealMotionLogo />
      </Link>
      <Link className='h-full w-full fill-black dark:fill-white' href='https://theiceji.com/'>
        <IceJiTriangleLogo />
      </Link>
      <Link className='h-full w-full fill-black dark:fill-white' href='https://artscape.day/'>
        <ArtScapeLogo />
      </Link>
    </>;
};
export { Footer };